import {Dimensions, DimensionValue, Platform, StyleSheet} from 'react-native';

const windowDim = Dimensions.get('window').width;
export const styles = StyleSheet.create({
  containerMenuItem:
    Platform.OS === 'web'
      ? {
          height: 156,
          margin: 12,
          padding: windowDim <= 400 ? 12 : 24,
          flexBasis: (windowDim <= 725
            ? 'calc(50% - 24px)'
            : 'calc(25% - 24px)') as DimensionValue,
          minWidth: (windowDim <= 400
            ? 'calc(100% - 24px)'
            : 'calc(25% - 24px)') as DimensionValue,
          backgroundColor: 'white',
          borderRadius: 16,
          alignItems: 'center',
          justifyContent: 'flex-start',
          flex: 1,
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
          elevation: 4,
        }
      : {
          margin: 10,
          flexDirection: 'column',
          width: '28%',
          alignItems: 'center',
          backgroundColor: 'white',
          paddingVertical: 20,
          paddingHorizontal: 10,
          marginLeft: 10,
          marginTop: 10,
          marginRight: 10,
          borderRadius: 20,
          elevation: 4,
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
        },

  resultContainer: {
    backgroundColor: '#f2f6f9',
    width: '100%',
    padding: 40,
    marginVertical: 40,
    borderRadius: 20,
  },
  resultDestination: {
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  resultMontant: {
    fontSize: 40,
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
});
